import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import defaultState from 'config/defaultState';
import {
  RECEIVE_PRIMARY_CONTENT,
  RECEIVE_SITE_OPTIONS,
} from 'config/types/action';
import abTesterReducer from './abTesterReducer';
import activeReducer from './activeReducer';
import archiveReducer from './archiveReducer';
import combineEntityReducers from './combineEntityReducers';
import createContentGroupReducer from './createContentGroupReducer';
import menuReducer from './menuReducer';
import createOptionReducer from './createOptionReducer';
import landingPageReducer from './landingPageReducer';
import userReducer from './userReducer';
import featureFlagReducer from './featureFlagReducer';

function createRootReducer(history) {
  const sliceReducers = combineReducers({
    abTester: abTesterReducer,
    active: (state = defaultState.active) => state,
    archive: (state = defaultState.archive) => state,
    landingPage: (state = defaultState.landingPage) => state,
    router: connectRouter(history),
    socialMedia: createOptionReducer('socialMedia'),
    languages: createOptionReducer('languages'),
    languagePicker: createOptionReducer('languagePicker'),
    translations: createOptionReducer('translations'),
    contentItem: createContentGroupReducer('contentType'),
    term: createContentGroupReducer('taxonomy'),
    menu: menuReducer,
    user: userReducer,
    featureFlags: featureFlagReducer,
    ...combineEntityReducers({
      author: RECEIVE_PRIMARY_CONTENT,
      contentType: RECEIVE_SITE_OPTIONS,
      info: RECEIVE_SITE_OPTIONS,
      taxonomy: RECEIVE_SITE_OPTIONS,
      footer: RECEIVE_SITE_OPTIONS,
      redirect: RECEIVE_SITE_OPTIONS,
    }),
  });
  return reduceReducers(
    sliceReducers,
    archiveReducer,
    landingPageReducer,
    activeReducer,
  );
}

export default createRootReducer;
